export default __webpack_public_path__ + "static/media/fireworks2.f149d32b.jpg";